import React, { Component } from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';

import SecureLayout from './layout/SecureLayout';

export default class App extends Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <Provider store={this.props.store}>
                <ConnectedRouter history={this.props.history}>
                    <SecureLayout />
                </ConnectedRouter>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js